import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertDialog, AlertDialogAction, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@mono/ui-components';
import { useEffect, useState } from 'react';
import { getTimeRemaining } from '../../lib/auth';
export function SessionWarningDialog({ open, onStayLoggedIn }) {
    const [secondsLeft, setSecondsLeft] = useState(0);
    useEffect(()=>{
        if (!open) return;
        const tick = ()=>{
            const remaining = getTimeRemaining();
            setSecondsLeft(Math.max(0, Math.ceil(remaining / 1000)));
        };
        tick();
        const interval = setInterval(tick, 1000);
        return ()=>clearInterval(interval);
    }, [
        open
    ]);
    return /*#__PURE__*/ _jsx(AlertDialog, {
        open: open,
        children: /*#__PURE__*/ _jsxs(AlertDialogContent, {
            children: [
                /*#__PURE__*/ _jsxs(AlertDialogHeader, {
                    children: [
                        /*#__PURE__*/ _jsx(AlertDialogTitle, {
                            children: "Session Expiring"
                        }),
                        /*#__PURE__*/ _jsxs(AlertDialogDescription, {
                            children: [
                                "Your session will expire in",
                                ' ',
                                /*#__PURE__*/ _jsxs("span", {
                                    className: "font-semibold tabular-nums",
                                    children: [
                                        secondsLeft,
                                        "s"
                                    ]
                                }),
                                ". Would you like to stay logged in?"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(AlertDialogFooter, {
                    children: /*#__PURE__*/ _jsx(AlertDialogAction, {
                        onClick: onStayLoggedIn,
                        children: "Stay Logged In"
                    })
                })
            ]
        })
    });
}
